export default "__VITE_ASSET__cb0a96ac__"